import { Skeleton } from '../ui/skeleton';
import { TableCell, TableRow } from '../ui/table';

import { Table } from '@tanstack/react-table';

interface TableRowSkeletonsProps<T> {
  table: Table<T>;
  rowCount?: number;
}

export function TableRowSkeletons<T>({ table, rowCount = 8 }: TableRowSkeletonsProps<T>) {
  const visibleColumns = table.getVisibleLeafColumns();

  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIdx) => (
        <TableRow key={rowIdx} className="h-[73px]">
          {visibleColumns.map((column) => (
            <TableCell key={column.id} className="p-4">
              <Skeleton className="h-8 w-full" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

